import type { IhandleDropOfProfileImage, IUploadNewProfileImageGeneric } from "../interfaces/ProfilePage.interface";

export function uploadNewProfileImageGeneric({
  imageFile,
  revalidateAccountData,
  accountApi,
  showSuccessSnackbar,
  showErrorSnackbar,
}: Readonly<IUploadNewProfileImageGeneric>) {
  accountApi
    .uploadProfileImage([imageFile])
    .then(() => {
      revalidateAccountData();
      showSuccessSnackbar("Immagine del profilo aggiornata con successo", { variant: "success" });
    })
    .catch((apiErrors) => {
      console.error(apiErrors);
      showErrorSnackbar("Errore durante l'aggiornamento dell'immagine del profilo", { variant: "error" });
    });
}

/**
 * Legacy function for backward compatibility with MLDialog
 * @deprecated Use uploadNewProfileImageGeneric for more flexibility
 */
export function uploadNewProfileImage({
  imageFile,
  revalidateAccountData,
  MLDialog,
  accountApi,
}: Readonly<IhandleDropOfProfileImage>) {
  uploadNewProfileImageGeneric({
    imageFile,
    revalidateAccountData,
    accountApi,
    showSuccessSnackbar: (message) => MLDialog.showSnackbar(message, { variant: "success" }),
    showErrorSnackbar: (message) => MLDialog.showSnackbar(message, { variant: "error" }),
  });
}
